import cookie from 'react-cookies';
import {
    CITYDOMAIN_COOKIE
} from '~/src/constants';

// включить форму с промокодом на /request
export const PROMOCODE_REQUEST = 'promocode_request';
// прятать доп. оборудоване в чеке на /request
export const HIDE_ADD_PRODUCT_REQUEST = 'hide_add_product_request';
// полная покупка включена
export const SELF_ORDER_ACTIVE = 'self_order_active';
// Пункты меню
export const SHOWING_MENU_ITEMS = 'showing_menu_items';
// Новая оплата
export const NEW_PAYMENT = 'new_payment';
// новая детальная страница тарифа
export const SHOWING_TARIFF_DETAIL = 'showing_tariff_detail';
export const LABEL_TARIFF_DETAIL_NEW = 'detail_new';
// popup Стать клиентом
export const BECOME_CLIENT = 'become_client';
export const LABEL_BECOME_CLIENT = 'pop_up';
// главное меню со скрытием
export const MENU_ITEM = 'menu_item';
export const HIDE_ITEM = 'hide_item';

const MAIN_URL = 'dom.ru';
const BETA_URL = 'beta.domru.ru';
const EXPIRES_FOR_COOKIE = 41;

const getMainUrlStartIndex = (url) => {
    if (url.indexOf('localhost') !== -1) {
        return url.indexOf('localhost');
    }
    if (url.indexOf('ertelecom.ru') !== -1) {
        var splitUrl = url.split('.');
        if (splitUrl.indexOf('t2') === 3) {
            // города нет в url
            return url.indexOf('//') + 2;
        } else {
            // город есть
            return url.indexOf(splitUrl[1]);
        }
    }
    if (url.indexOf(BETA_URL) !== -1) {
        return url.indexOf(BETA_URL);
    }
    return url.indexOf(MAIN_URL);
};

const getCityFromUrl = (url) => {
    var mainUrlStart = getMainUrlStartIndex(url);
    var hostStart = url.indexOf('//') + 2;
    return mainUrlStart !== hostStart ? url.slice(hostStart, mainUrlStart - 1) : '';
};

const changeUrlCity = (newCitydomain) => {
    if (process.browser) {
        if (document.location.href.indexOf('ui-react.components.t2.ertelecom.ru') === -1) {
            var currentCity = getCityFromUrl(document.location.href);
            if (newCitydomain === currentCity) {
                return;
            }
            var oldHref = document.location.href;
            var mainUrlStart = getMainUrlStartIndex(oldHref);
            var newHref = currentCity ? oldHref.replace(currentCity, newCitydomain) : oldHref.slice(0, mainUrlStart) + newCitydomain + '.' + oldHref.slice(mainUrlStart);
            document.location.href = newHref;
        }
    }
};

export const getCookieDomain = () => {
    return process.env.COOKIE_DOMAIN;
};

const getCookieParams = () => {
    const expires = new Date();
    expires.setDate(expires.getDate() + EXPIRES_FOR_COOKIE);
    const COOKIE_DOMAIN = getCookieDomain();
    return COOKIE_DOMAIN
        ? {
            expires,
            domain: COOKIE_DOMAIN,
            path: '/'
        }
        : {};
};

export const changeCity = (newCitydomain) => {
    const COOKIE_PARAMS = getCookieParams();
    cookie.save(CITYDOMAIN_COOKIE, newCitydomain, COOKIE_PARAMS);
    changeUrlCity(newCitydomain);
};

export const detectCity = (reqUrl) => {
    if (process.browser) {
        reqUrl = document.location.href;
    }
    var cookieCity = cookie.load(CITYDOMAIN_COOKIE);
    var urlCity = getCityFromUrl(reqUrl);
    if (cookieCity && urlCity && cookieCity === detectCity) {
        return cookieCity;
    }

    if (urlCity) {
        const COOKIE_PARAMS = getCookieParams();
        cookie.save(CITYDOMAIN_COOKIE, urlCity, COOKIE_PARAMS);
        return urlCity;
    }
    if (cookieCity) {
        changeUrlCity(cookieCity);
        return cookieCity;
    }
    return '';
};

export const cityGetProp = (city, prop) => {
    const el = city?.abnTests?.find((el) => el.name === prop);
    return el ? !!el.is_active : false;
};

export const isDevDomain = (domain) => {
    return domain.indexOf('dev') > -1 || domain.indexOf('testing') > -1;
};
